module.exports = __webpack_public_path__ + "img/4.e5fe0082.jpg";